import {AbstractRepository} from '../repository/AbstractRepository';
import {ResourceRegistry} from '../registry/ResourceRegistry';
import {context} from '../app-context/AppContext';

export class ApiRegistryRepository extends AbstractRepository<ResourceRegistry> {
    constructor() {
        super({
            apiUrl: context.registryApi,
        });
    }

    resourceBuilder(data: any): ResourceRegistry {
        return new ResourceRegistry(data._links, context.extendedRegistry);
    }
}
